import React from 'react'
import { Select, SelectProps } from '@pankod/refine-antd'
import { availableLanguages } from 'utility/languages'

type LanguageSelectProps = SelectProps & {
  /** When set, that language value is omitted from the dropdown (e.g. target lang ≠ base lang). */
  excludeValue?: string | null
}

export const LanguageSelect: React.FC<LanguageSelectProps> = ({ excludeValue, options, ...props }) => {
  const languageOptions =
    options ??
    (excludeValue
      ? availableLanguages.filter(lang => lang.value !== excludeValue)
      : availableLanguages)

  return <Select showSearch optionFilterProp="label" options={languageOptions} {...props} />
}
